<template>
  <div>
    <div class="van-hairline--bottom"></div>
    <div class="scan-a" @click="scan()">
      <span>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-saoyisao"></use>
        </svg>
      </span>
      <p>扫一扫</p>
    </div>
    <div class="scan-order">
      <div class="s-o-l">
        <span>{{ orderTitle }}</span>
        <span>{{ memberTitle }}</span>
      </div>
      <div class="s-o-r">
        <van-button type="info" size="small" @click="addRwm">手动添加编号</van-button>
      </div>
    </div>
    <div class="van-hairline--bottom"></div>
    <div class="scan-main">
      <van-cell value="防伪码编号：" />
      <div class="scan-code">
        <van-cell-group v-for="code in codes" :key="code.id">
          <van-cell :title="code.code" :value="code.id" />
        </van-cell-group>
      </div>
    </div>
    <van-submit-bar button-text="提交订单" @submit="onSubmit" />

    <van-dialog v-model="show" title="手动添加编号" show-cancel-button :before-close="beforeClose">
      <van-field
        v-model="info.code"
        name="二维码编号"
        label="二维码编号"
        type="number"
        placeholder="请输入编号"
        :rules="[{ required: true, message: '请输入编号' }]"
      />
    </van-dialog>

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { Cell, CellGroup, SubmitBar, Button, Dialog, Popup } from 'vant'
  import wx from 'weixin-jsapi'

  export default {
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Button.name]: Button,
      [SubmitBar.name]: SubmitBar,
      [Popup.name]: Popup,
      [Dialog.Component.name]: Dialog.Component
    },
    name: 'retails',
    data() {
      return {
        show: false,
        active: 0,
        userInfo: this.$store.state,
        shareLink: process.env.DOMAIN_NAME,
        order: null,
        orderTitle: '',
        memberTitle: '',
        codes: [],
        info: {
          code: ''
        }
      }
    },
    created() {
      if(this.userInfo.name != null) {
        this.userInfo.username = this.userInfo.name
      }else if(this.userInfo.nickname != null) {
        this.userInfo.username = this.userInfo.nickname
      }
     this.getData()
     //let shareLink = window.location.href

     // 判断 是什么端解决ios 的兼容问题，如果是安卓端则直接把整个url传给后台就行，要是ios 则需要截取#号
     var u = navigator.userAgent;
     var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
     let shareLink = null
     if (isAndroid) {
       shareLink = window.location.href;
     }
     if (isiOS) {
       shareLink = window.location.href.split('#')[0];
       //shareLink= encodeURIComponent(window.location.href.split('#')[0]);
     }

     //this.getJssdkConfig("onMenuShareTimeline,checkJsApi,onMenuShareAppMessage,translateVoice,scanQRCode,openCard",true,false,shareLink);

      let apis = "checkJsApi,onMenuShareTimeline,onMenuShareAppMessage,translateVoice,scanQRCode,openCard";
      this.$api.get('jssdkConfig', {apis:apis, debug:false, json:false, url: shareLink}, r=>{
        //let config = JSON.parse(r.result)
        //wx.config(config)
        wx.config({
          debug: false,
          appId: r.data.appId,
          timestamp: r.data.timestamp,
          nonceStr: r.data.nonceStr,
          signature: r.data.signature,
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'translateVoice',
            'hideMenuItems',
            'showMenuItems',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
          ]
        });

        wx.ready(function() {
          var shareData = {
            title: '防伪码查询',
            desc: '绀发产品防伪码查询',
            link: shareLink,
            imgUrl: 'https://xy.itxwzj.com/statics/wap/images/1.jpg',
            success: function () {
              //$.get('/shareHits/'+$("#act_id").val(),{},function(){});
            }
          }
          wx.hideOptionMenu();
          wx.onMenuShareAppMessage(shareData)
          wx.onMenuShareTimeline(shareData)
        })
        wx.error(function(error){
          //console.log(error)
        })
      })

    },
    methods: {
      getData() {
        this.$api.get('fw/order/show', {id: this.$route.query.id}, r=>{
          this.order = r.result
          this.orderTitle = '订单编号：' + this.order.order_sn
          this.memberTitle = '会员ID：' + this.order.user_id + '，会员姓名：' + this.order.user_name
        })
      },
      onSubmit() {
        if(this.codes.length > 0) {
          this.$api.post('fw/storeCode', {codes:this.codes, order: this.order, uid: localStorage.getItem('uid')}, r=>{
            if(r.status === 200){
              this.$router.push({name: 'orders'})
            }
          })
        }else {
          this.$toast('您未添加防伪编码')
        }
      },
      getJssdkConfig(apis,debug,json,link){
        let self = this
        this.$api.get('jssdkConfig', {apis:apis, debug:debug, json:json, url: link}, r=>{
          let config = JSON.parse(r.result)
          wx.config(config)
          wx.ready(function() {
            var shareData = {
              title: '防伪码查询',
              desc: '绀发产品防伪码查询',
              link: self.shareLink,
              imgUrl: 'https://xy.itxwzj.com/statics/wap/images/1.jpg',
              success: function () {
                //$.get('/shareHits/'+$("#act_id").val(),{},function(){});
              }
            }
            wx.showOptionMenu();
            wx.onMenuShareAppMessage(shareData)
            wx.onMenuShareTimeline(shareData)
          })
          wx.error(function(error){
            //console.log(error)
          })
        })
      },
      scan(){
        let _self = this
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            let urlArray = result.split('?')
            let urlParams = urlArray[1].split('=')
            let codeStatus = 0
            _self.codes.map(code=>{
              if(code.id == urlParams[1]) {
                codeStatus = 1
                return
              }
            })
            if(codeStatus === 0) {
              _self.$api.get('fw/code', {id: urlParams[1]}, r=>{
                let result = r.result
                if(result.status === 0){
                  _self.codes.push(result)
                }
              })
            }else{
              _self.$toast('该编号已经添加过')
            }
          },
          fail: function(res){
            alert(JSON.stringify(res));
          }
        })
      },
      addRwm() {
        this.show = true
      },
      beforeClose : function (action, done) { // 点击事件 - 备注按钮提示框
        let _self = this
        if (action === 'confirm') { // 确认
          if(this.info.code == ''){
            this.$toast('请输入编号')
            done(false)
            return
          }
          _self.$api.get('fw/code', {code: this.info.code}, r=>{
            let result = r.result
            if(result.status === 0){
              let codeStatus = 0
              _self.codes.map(item => {
                if(item.code == result.code){
                  codeStatus = 1
                  return false
                }
              })
              if(codeStatus == 0) {
                _self.codes.push(result)
              }else{
                _self.$toast('该编号已添加')
              }
              this.info.code = ''
              done();
            }
          })
        } else if (action === 'cancel') { // 取消
          this.info.code = ''
          done();
        }
      }
    }
  }
</script>

<style scoped>
  .scan-a{
    text-align: center;
    background: #ffffff;
    padding: 15px 0;
  }
  .scan-a span{
    font-size: 90px;
  }
  .scan-a p{
    margin-top: 0;
  }
  .scan-main{
    background: #ffffff;
    padding:3%;
    margin-top: 10px;
  }
  .scan-main .scan-code{
    font-weight: bold;
  }
  .scan-order{
    overflow: hidden;
    font-size: 14px;
    padding:3%;
    background: #ffffff;
  }
  .scan-order .s-o-l{
    float: left;
    width: 60%;
  }
  .scan-order .s-o-l span{
    display: block;
    margin-bottom: 10px;
  }
  .scan-order .s-o-r{
    float: right;
    width: 40%;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/orders/scan.vue